import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import SpaIcon from '@mui/icons-material/Spa';
import TranslateIcon from '@mui/icons-material/Translate';
import { Link } from 'react-router-dom';
import LogoutButton from './LogoutButton';

function Sidebar() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [cosmeticAvailable, setCosmeticAvailable] = useState(true);
    const [userCountry, setUserCountry] = useState(null);

    useEffect(() => {
        const token = sessionStorage.getItem('token');
        axios.get('/cosmeticProducts', { headers: { 'x-access-token': token } })
            .then((res) => {
                const data = res.data;
                if (Array.isArray(data) && data.length > 0) {
                    setCosmeticAvailable(true);
                } else {
                    setCosmeticAvailable(false);
                }
            })
            .catch(() => {
                // Treat errors as no data available
                setCosmeticAvailable(false);
            });

        // Fetch user country to hide/show country-specific menu items
        axios.get('/user/country', { headers: { 'x-access-token': token } })
            .then((res) => {
                if (res && res.data && res.data.country) {
                    setUserCountry(res.data.country);
                }
            })
            .catch(() => {
                // silently ignore
            });
    }, []);

    const isCosmeticsDisabled = !cosmeticAvailable;

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    return (
        <div>
            <IconButton edge="start" color="inherit" onClick={toggleDrawer(true)} aria-label="menu">
                <MenuIcon />
            </IconButton>

            <Drawer open={drawerOpen} onClose={toggleDrawer(false)} style={{ width: 1200 }}>
                <div role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
                <List>
                    <ListItem button key="Dashboard" component={Link} to="/">
                        <ListItemIcon><HomeIcon /></ListItemIcon>
                        <ListItemText primary="Dashboard" />
                    </ListItem>
                    <ListItem button key="Liste des médicaments" component={Link} to="/medicaments">
                        <ListItemIcon><InfoIcon /></ListItemIcon>
                        <ListItemText primary="Liste des médicaments" />
                    </ListItem>
                    {/* interactions and PCT lists hidden for DZ users (for now)*/}
                    {userCountry !== 'DZ' && (
                        <ListItem button key="Liste des interactions" component={Link} to="/interactions">
                            <ListItemIcon><InfoIcon /></ListItemIcon>
                            <ListItemText primary="Liste des interactions" />
                        </ListItem>
                    )}
                    {userCountry !== 'DZ' && (
                        <ListItem button key="Liste des médicaments PCT" component={Link} to="/pct_meds">
                        <ListItemIcon><InfoIcon /></ListItemIcon>
                        <ListItemText primary="Liste des médicaments PCT" />
                        </ListItem>
                    )}
                    <ListItem button key="Suggestion de médicaments" component={Link} to="/suggestions">
                        <ListItemIcon><InfoIcon /></ListItemIcon>
                        <ListItemText primary="Suggestion de médicaments" />
                    </ListItem>
                    <ListItem button key="Problèmes reportés" component={Link} to="/Problems">
                        <ListItemIcon><InfoIcon /></ListItemIcon>
                        <ListItemText primary="problèmes reportés" />
                    </ListItem>
                    <ListItem button key="Pathologies" component={Link} to="/pathologies">
                        <ListItemIcon><CoronavirusIcon /></ListItemIcon>
                        <ListItemText primary="Pathologies" />
                    </ListItem>
                    <ListItem button key="Traductions" component={Link} to="/translations-fr-ar">
                        <ListItemIcon><TranslateIcon /></ListItemIcon>
                        <ListItemText primary="Traductions FR/AR" />
                    </ListItem>
                    <Tooltip title={isCosmeticsDisabled ? 'Produits cosmetiques non disponibles pour le moment' : ''} placement="right">
                        <span onClick={(e) => { if (isCosmeticsDisabled) e.stopPropagation(); }}>
                            <ListItem
                                button
                                key="Cosmetic"
                                component={isCosmeticsDisabled ? 'li' : Link}
                                to={isCosmeticsDisabled ? undefined : '/cosmetic'}
                                disabled={isCosmeticsDisabled}
                                sx={isCosmeticsDisabled ? { opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'all !important' } : {}}
                            >
                                <ListItemIcon><InfoIcon /></ListItemIcon>
                                <ListItemText primary="Liste des produits cosmetiques" />
                            </ListItem>
                        </span>
                    </Tooltip>
                    {/* <ListItem button key="Dermo Medicines" component={Link} to="/dermo-medicines">
                        <ListItemIcon><InfoIcon /></ListItemIcon>
                        <ListItemText primary="Liste des médicaments dermo" />
                    </ListItem> */}
                    <ListItem button key="Dermo Plaints" component={Link} to="/dermo-plaints">
                        <ListItemIcon><SpaIcon /></ListItemIcon>
                        <ListItemText primary="Dermo plaints" />
                    </ListItem>
                    <LogoutButton />
                </List>
                </div>
            </Drawer>
        </div>
    );
}

export default Sidebar;
